var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2DownloadProblem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 61v4H13v-4h50zM51.48 43s3.23-25.28 3.23-26.4a4.08 4.08 0 00-8.15 0c0 1.12 2.92 26.4 2.92 26.4h2zm-4.85 9a4 4 0 108 0 4 4 0 00-8 0zM40 45h-9V12h-4v33h-9l11 11.93L40 45z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Download_problem.b38e7e66.svg";
export { SvgJ2DownloadProblem as ReactComponent };